import React from "react";
import trans from "../../../utils";
import PopupBodyItem from "../../Helpers/Popup/PopupParts/PopupBodyItem";
import VehicleAttachments from "../../Vehicles/VehicleInf/VehicleAttachments";

export default function POIsExtra({ poidetails }) {
	const getValue = (val) => {
		if (val === true) {
			return trans("on");
		} else if (val === false) {
			return trans("off");
		} else {
			return val;
		}
	};
	return (
		<>
			{poidetails?.attachments?.length > 0 && (
				<>
					<VehicleAttachments values={poidetails?.attachments} />
				</>
			)}
			{poidetails?.customAttributes?.length > 0 && (
				<div className="row">
					<div className="col-lg-12">
						<p className="fs-16 fw-500 brand-700 text-uppercase">
							{trans("Custom Attributes")}
						</p>
						{poidetails?.customAttributes?.map((i, index) => (
							<div key={index} className="display-border">
								<PopupBodyItem title={i?.name} item={getValue(i?.value)} />
							</div>
						))}
					</div>
				</div>
			)}
			{poidetails?.contractorLogo ||
			poidetails?.customer1Logo ||
			poidetails?.customer2Logo ||
			poidetails?.consultantLogo ? (
				<div className="row">
					<p className="fs-16 fw-500 brand-700 text-uppercase">
						{trans("Logos")}
					</p>
					<div className="col-lg-4">
						{poidetails?.contractorLogo && (
							<>
								<img
									src={poidetails.contractorLogo}
									alt="preview"
									width={80}
									height={80}
									style={{
										objectFit: "cover",
										borderRadius: 8,
									}}
								/>
								<div className="mt-2">{trans("Contractor")}</div>
							</>
						)}
					</div>
					<div className="col-lg-4">
						{poidetails?.customer1Logo && (
							<>
								<img
									src={poidetails.customer1Logo}
									alt="preview"
									width={80}
									height={80}
									style={{
										objectFit: "cover",
										borderRadius: 8,
									}}
								/>
								<div className="mt-2">{trans("Customer 1")}</div>
							</>
						)}
					</div>
					<div className="col-lg-4">
						{poidetails?.customer2Logo && (
							<>
								<img
									src={poidetails.customer2Logo}
									alt="preview"
									width={80}
									height={80}
									style={{
										objectFit: "cover",
										borderRadius: 8,
									}}
								/>
								<div className="mt-2">{trans("Customer 2")}</div>
							</>
						)}
					</div>
					<div className="col-lg-4">
						{poidetails?.consultantLogo && (
							<>
								<img
									src={poidetails.consultantLogo}
									alt="preview"
									width={80}
									height={80}
									style={{
										objectFit: "cover",
										borderRadius: 8,
									}}
								/>
								<div className="mt-2">{trans("Consultant")}</div>
							</>
						)}
					</div>
				</div>
			) : null}
			{(poidetails?.customAttributes?.length || 0) === 0 &&
				(poidetails?.attachments?.length || 0) === 0 && (
					<div
						className="d-flex align-items-center justify-content-center"
						style={{ height: "300px" }}
					>
						{trans("No data")}
					</div>
				)}
		</>
	);
}
